import {post, put} from "../util/http.service";

export const createCar = car => post("/cars", car);

export const updateCar = (id, car) => put("/cars/" + id, car);

export const updatePositions = ids => put("/cars/positions", {ids});
